package com.milta.core.localization.translations.de

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Ladeadresse",
    emptyMessage = "Um die Tour zu optimieren, geben Sie an, wo Ihre Fahrer die Waren laden. Die Adresse wird für Ihre nächsten Touren gespeichert.",
    selectPlaceholder = "Ladeadresse auswählen",
    sheetSubtitle = "Wo Ihre Fahrer die Waren abholen.",
    startPointBadge = "Startpunkt",
    newAddressAction = "Neue Adresse",
    mobileSearchPlaceholder = "Straße, Hausnummer, Ort",
    webSearchPlaceholder = "Adresse suchen…",
    deleteDialogTitle = "Diese Adresse löschen?",
    deleteDialogMessage = "„%s“ wird nicht mehr vorgeschlagen. Bereits erstellte Touren bleiben unverändert.",
    webSubmitBlockedHint = "Wählen Sie eine Ladeadresse, um zu optimieren.",
    errorRequired = "Wählen Sie eine Ladeadresse.",
)
